import { FavouriteProduct } from 'store/favourite/types';
import { SearchResultProduct } from 'store/search/types';

const toSearchResultProduct = (p: FavouriteProduct) => {
  const result = {
    id: String(p.favouriteId),
    image: p.product.previewUrl,
    categoryId: p.product.categoryId,
    deepLink: p.product.deepLink,
    name: p.product.name,
    productId: p.product.productId,
    productTypeId: p.product.productTypeId,
    subTitle: '',
    url: p.product.productPageUrl,
    productTier: p.product.productTier,
    sku: p.sku,
    favourited: true,
  } as SearchResultProduct;

  return result;
};

export default toSearchResultProduct;
